// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1YXNG","footer":"ModalCreateQualiphyProcedure_footer__9vQQA","additionData":"ModalCreateQualiphyProcedure_additionData__OJwm2"};